var _g, _circle, _circle2, _circle3, _g2, _path, _circle4, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppreciation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 95,
    viewBox: "0 0 180 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Award 4",
    filter: "url(#filter0_d_3684_50730)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 36",
    d: "M39.2441 16.1133L39.2441 50.3911L8.52768 50.3911L17.5423 33.2522L1.75077 16.1133L39.2441 16.1133Z",
    fill: "#983333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 37",
    d: "M130.258 16.1133L130.258 50.3911L160.974 50.3911L151.96 33.2522L167.751 16.1133L130.258 16.1133Z",
    fill: "#983333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34",
    d: "M30.3379 22.5644L39.2412 16.1133V58.4041H30.3379V22.5644Z",
    fill: "#552727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 38",
    d: "M139.156 22.5644L130.253 16.1133V58.4041H139.156V22.5644Z",
    fill: "#552727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25",
    d: "M50.7422 22.5312L50.7422 61.7245L29.3048 61.7245C29.3048 61.7245 26.6233 61.7245 26.6233 42.1279C26.6233 22.5313 29.3048 22.5313 29.3048 22.5313L50.7422 22.5312Z",
    fill: "#CE4444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M120.84 22.5312L120.84 61.7245L140.937 61.7245C140.937 61.7245 143.451 61.7245 143.451 42.1279C143.451 22.5313 140.937 22.5313 140.937 22.5313L120.84 22.5312Z",
    fill: "#CE4444"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 84.8934,
    cy: 42.284,
    r: 40.7957,
    fill: "url(#paint0_linear_3684_50730)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 84.7471,
    cy: 42.3799,
    r: 32.4971,
    fill: "url(#paint1_linear_3684_50730)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3684_50730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 17,
    width: 57,
    height: 57
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 86.2033,
    cy: 45.2169,
    r: 27.9044,
    fill: "#7D7D7D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3684_50730)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 84.7169,
    cy: 42.2443,
    r: 27.9044,
    fill: "#9CA1A3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_2",
    d: "M84.7463 73.3717C102.09 73.3717 116.182 59.4153 116.182 42.1585C116.182 24.9018 102.09 10.9453 84.7463 10.9453C67.4031 10.9453 53.3105 24.9018 53.3105 42.1585C53.3105 59.4153 67.4031 73.3717 84.7463 73.3717Z",
    fill: "#644314",
    stroke: "#FBBF4C",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3684_50730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 16,
    width: 59,
    height: 58
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4_2",
    cx: 86.3237,
    cy: 45.0424,
    r: 28.9467,
    fill: "#C28B37"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3684_50730)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3_3",
    cx: 84.7846,
    cy: 41.9623,
    r: 28.9467,
    fill: "url(#paint2_linear_3684_50730)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2865 20.9199L91.8156 33.9781L104.874 35.6104L95.9072 45.6652L98.3447 60.0945L85.2865 53.5654L72.2283 60.0945L74.6876 45.6652L65.6992 35.6104L78.7574 33.9781L85.2865 20.9199Z",
    fill: "url(#paint3_linear_3684_50730)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.181 20.4727L85.2865 18.6839L84.3921 20.4727L78.1023 33.0522L65.5752 34.6181L63.6824 34.8547L64.9537 36.2769L73.6209 45.9723L71.2425 59.9265L70.9111 61.8712L72.6755 60.989L85.2865 54.6835L97.8975 60.989L99.6588 61.8696L99.3308 59.928L96.9732 45.9723L105.62 36.276L106.888 34.8544L104.998 34.6181L92.4707 33.0522L86.181 20.4727Z",
    stroke: "#353535",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3684_50730",
    x: 0.966502,
    y: 0.704783,
    width: 178.538,
    height: 94.1278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3684_50730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3684_50730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3684_50730",
    x1: 84.8934,
    y1: 1.48828,
    x2: 84.8934,
    y2: 83.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B16F07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3684_50730",
    x1: 84.7471,
    y1: 9.88281,
    x2: 84.7471,
    y2: 74.8771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F5F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3684_50730",
    x1: 84.7846,
    y1: 13.0156,
    x2: 84.7846,
    y2: 70.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A36D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744A0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3684_50730",
    x1: 85.2865,
    y1: 33.5079,
    x2: 85.2865,
    y2: 58.4273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppreciation);
export default __webpack_public_path__ + "static/media/Appreciation.992cda05e8620ae84e8a46c9f46d6de0.svg";
export { ForwardRef as ReactComponent };